var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckMark = function SvgCheckMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.694.476a1.29 1.29 0 0 1-.088 1.727L6.303 9.505a1.288 1.288 0 0 1-1.824 0L.71 5.738a1.29 1.29 0 1 1 1.825-1.824L5.39 6.768l6.39-6.39A1.289 1.289 0 0 1 13.508.29l.098.088.088.098Z",
    fill: "#fff"
  })));
};
export default SvgCheckMark;